export const DASHBOARD_PRODUCT_STATUS_WIDGETS_PERIOD = '30d'
export const DASHBOARD_PRODUCT_STATUS_WIDGETS_SIZES = 12
